let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dfeY8")).then(() => parcelRequire('hvJbJ'));